import React from "react";
import { Logo } from "../../components/Logo";
import { PageFooter } from "../../components/PageFooter";
import "./index.css";

export function ConnectionSuccess() {
  return (
    <div className="connection-success-wrapper">
      {/* メインコンテンツ */}
      <div className="connection-success-content">
        {/* ロゴ */}
        <Logo />

        {/* 成功メッセージ */}
        <div className="success-message">
          <h1 className="success-title">ID Connection Successful</h1>
        </div>
      </div>

      {/* フッター */}
      <PageFooter className="fixed" />
    </div>
  );
}

